<div class="portal-page-container portal container-fluid pr-md-0">
  <div class="row">
    <app-side-menu [isCollapsed]="toggle" (toggleCollapse)="toggleMenu($event)"></app-side-menu>
    <div class="col portal-page">
      <app-header-bar (toggleMenu)="toggleMenu($event)"></app-header-bar>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<div class="overlay"></div>